import React from 'react'
import PropTypes from 'prop-types'

const SelectionTab = ({ display, selected, onClick }) => {
  return (
    <div style={styles.tab(selected)} onClick={onClick}>
      { display }
    </div>
  )
}

SelectionTab.propTypes = {
  display: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}

const TABS = [
  { key: 'pastJobs', display: 'Past Jobs' },
  { key: 'futureJobs', display: 'Future Jobs' },
  { key: 'invoices', display: 'Invoices' }
]

class SummaryTabsHeader extends React.Component {

  static propTypes = {
    style: PropTypes.object.isRequired,
    onTabSelected: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedTabKey: 'pastJobs'
    }
  }

  componentWillMount(){
    this.props.onTabSelected(this.state.selectedTabKey)
  }

  handleTabClicked = tab => {
    this.setState({ selectedTabKey: tab.key })
    this.props.onTabSelected(tab.key)
  }

  render() {
    return (
      <div style={{ ...styles.container, ...this.props.style }}>
        {
          TABS.map(tab =>
            <SelectionTab
              key={tab.key}
              display={tab.display}
              selected={this.state.selectedTabKey === tab.key}
              onClick={() => this.handleTabClicked(tab)} />)
        }
        <div style={{ flex: 1, borderBottom: '0.4px solid #9b9b9b' }} />
      </div>
    )
  }

}

export default SummaryTabsHeader

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row'
  },
  tab: selected => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: selected ? '4px solid #356992' : '4px solid transparent',
    borderBottom: selected ? null : '0.4px solid #9b9b9b',
    borderLeft: selected ? '0.4px solid #9b9b9b' : null,
    borderRight: selected ? '0.4px solid #9b9b9b' : null,
    fontSize: 14,
    color: '#494949',
    cursor: 'pointer',
    height: 32,
    width: 115
  })
}



// WEBPACK FOOTER //
// ./src/customer/CustomerSummary/SummaryTabsHeader.js